import { render, staticRenderFns } from "./SideBarMakeup.vue?vue&type=template&id=06f837df"
import script from "./SideBarMakeup.vue?vue&type=script&lang=js"
export * from "./SideBarMakeup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports